import { isDTS } from "./platform";

export const SITE_DISPLAY_NAME = "Dream Sports";
export const SITE_DOMAIN_LABEL = "DreamSports.com";

// compliance-ok: PPH wording; DTS renders getFaqIntroCopy() below
export const FAQ_INTRO_COPY = `Nothing compares to online betting at ${SITE_DISPLAY_NAME}. We've got the best odds, and hundreds of sports for you to choose from.`;

/** FAQ intro for this platform. FAQ_INTRO_COPY is the PPH wording and is never shown on DTS. */
export const getFaqIntroCopy = () =>
  isDTS()
    ? `Nothing compares to social sports play at ${SITE_DISPLAY_NAME}. We've got the best odds, and hundreds of sports for you to choose from.`
    : FAQ_INTRO_COPY;

export const COPYRIGHT_LINE = (year = new Date().getFullYear()) =>
  `${SITE_DOMAIN_LABEL} © ${year} All Rights Reserved.`;

/** User-visible labels that replaced legacy Mobius naming. */
export const LIVE_SECTION_LABEL = "Live";
